import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MipManageState {
	selectedProgrammeMemberId: string | null;
	shouldDisableIsContactPerson: boolean;
}

const initialState: MipManageState = {
	selectedProgrammeMemberId: null,
	shouldDisableIsContactPerson: false,
};

const mipManageSlice = createSlice({
	name: 'mipManage',
	initialState,
	reducers: {
		setSelectedProgrammeMemberId: (state, action: PayloadAction<string | null>) => {
			state.selectedProgrammeMemberId = action.payload;
		},
		setShouldDisableIsContactPerson: (state, action: PayloadAction<boolean>) => {
			state.shouldDisableIsContactPerson = action.payload;
		},
	},
});

export const { setSelectedProgrammeMemberId, setShouldDisableIsContactPerson } =
	mipManageSlice.actions;
export const MipManage = mipManageSlice.reducer;
